module.exports = __webpack_public_path__ + "fonts/DirtyBrush.1ce2051.woff2";